/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_EmailInputs */



/**
* | output |
* | --- |
* | "Email" |
*
* @param {Options_Watermark_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_email = /** @type {((inputs?: Options_Watermark_EmailInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_EmailInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("E-mail")
	if (locale === "de") return /** @type {LocalizedString} */ ("E-Mail")
	if (locale === "it") return /** @type {LocalizedString} */ ("E-mail")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Эл. почта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Correo electrónico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("电子邮件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メールアドレス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ईमेल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("E-mail")
	return /** @type {LocalizedString} */ ("Email")
});